import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../_shared/shared.service';
import { Participant } from './models/processing.models';

@Injectable({
	providedIn: 'root',
})
export class ProcessingService extends SharedService {
	constructor(http: HttpClient) {
		super(http);
	}

	generateUid() {
		return this._http.get<any>(`${this.api}/participants/generateUid`);
	}

	getParticipants(sessionUniqueId: string) {
		return this._http.get<any>(`${this.api}/participants/${sessionUniqueId}`);
	}

	saveParticipant(participant: Participant) {
		return this._http.post<any>(`${this.api}/participants`, participant);
	}

	deleteParticipant(participantId: number) {
		return this._http.delete<any>(`${this.api}/participants/${participantId}`);
	}
}
